/**
 * EmptyState Component
 * 
 * Displays a centered message with an icon when content is empty or unavailable.
 * Used for empty lists, disabled features, or "coming soon" pages.
 */

import React from 'react';

const EmptyState = ({ 
  icon, 
  title, 
  description, 
  action 
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      {/* Icon */}
      {icon && (
        <div className="w-16 h-16 rounded-full bg-neutral-100 dark:bg-neutral-800 flex items-center justify-center mb-4">
          {icon}
        </div>
      )}

      {/* Title */}
      {title && (
        <h3 className="text-lg font-semibold text-neutral-900 dark:text-white mb-2">
          {title}
        </h3>
      )}

      {/* Description */}
      {description && (
        <p className="text-sm text-neutral-600 dark:text-neutral-400 text-center max-w-md mb-6">
          {description}
        </p>
      )}

      {/* Optional action button */}
      {action && action}
    </div>
  );
};

export default EmptyState;

